// src/hooks/useFileDownload.ts
import {useState, useCallback} from 'react';
import {AxiosProgressEvent} from 'axios';
import {apiClient} from '../api/apiClient';

interface UseFileDownloadOptions {
    onSuccess: (message: string) => void;
    onError: (message: string) => void;
    onStart: () => void;
    onSettled: () => void;
}

export const useFileDownload = ({onSuccess, onError, onStart, onSettled}: UseFileDownloadOptions) => {
    const [isDownloading, setIsDownloading] = useState(false);
    const [progress, setProgress] = useState(0);

    const downloadFile = useCallback(async (requestData: string) => {
        if (!requestData) {
            onError("Lütfen güncelleme alanını boş geçmeyiniz.");
            return;
        }

        setIsDownloading(true);
        setProgress(0);
        onStart();

        try {
            const response = await apiClient.post('/update/hakedis/file-update',
                {requestData},
                {
                    responseType: 'blob',
                    onDownloadProgress: (progressEvent: AxiosProgressEvent) => {
                        const total = progressEvent.total || 325000000;
                        setProgress(Math.floor((progressEvent.loaded / total) * 100));
                    }
                }
            );

            if (response.data.type === 'application/json') {
                const textData = await response.data.text();
                const errorResponse = JSON.parse(textData);
                throw new Error(errorResponse.message || "Güncelleme sırasında bir hata oluştu.");
            }

            const fileBlob = new Blob([response.data], {type: 'application/zip'});
            const url = window.URL.createObjectURL(fileBlob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'hakedisplus-update.oskaupdate');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            onSuccess("Güncelleme başarıyla indirildi.");
        } catch (error: any) {
            onError(error.message || "İndirme işlemi sırasında beklenmeyen bir hata oluştu.");
        } finally {
            setIsDownloading(false);
            onSettled();
            setTimeout(() => setProgress(0), 1000);
        }
    }, [onSuccess, onError, onStart, onSettled]);

    return {downloadFile, isDownloading, progress};
};